import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuscadorGeneralComponent } from './buscador-general.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [BuscadorGeneralComponent],
  exports: [BuscadorGeneralComponent]
})
export class BuscadorGeneralModule { }
